import { ITranslationRequest } from "../base/translation";
import { IChildCat } from "../category/request";
import { ILocation } from "./response";

export interface ICreateStore {
  status: number;
  type: number;
  firstPhone: string;
  secondPhone: string;
  address: string;
  note: ITranslationRequest;
  cityId: number;
  location?: ILocation;
  endWorkingTime: string;
  freeDelivery: boolean;
  pharmacyPromotion: boolean;
  minOrderValueForFreeDelivery: number ;
  maxOrderValueForFreeDelivery: number ;
  operationStoreCategoryId: number ;
  startWorkingTime: string;
  imageId: number;
  hasOffers: boolean;

  logoId: number;
  tagIds: number[];
  workStatus: number;
  acceptedExchange: boolean;
  childCategories?: IChildCat[];
  visibilityRadiusMeters?: number;
}
export interface ICopyStoreProducts {
  firstStoreId: number;
  secondStoreId: number;
}

export interface IUpdateStore extends ICreateStore {}

export interface IExportStoreExcel {
  id: boolean;
  name: boolean;
  city: boolean;
  type: boolean;
  firstPhone: boolean;
  status: boolean;
  minOrderValueForFreeDelivery: number ;
  maxOrderValueForFreeDelivery: number ;
  workStatus: boolean;
  createdAt: boolean;
  pharmacyPromotion: boolean;
}

export const colomnsExportStoreExcel = [
  "id",
  "name",
  "city",
  "type",
  "firstPhone",
  "status",
  "workStatus",
  "createdAt",
  "pharmacyPromotion",
];
